import { caseFilterhash } from '@debbie/common/dist/insights/index.js';
import * as authActions from './auth/actions.js';
import * as caseActions from './case/actions.js';
import * as caseVouchersActions from './case-vouchers/actions.js';
import * as casesActions from './cases/actions.js';
import * as creditorsActions from './creditors/actions.js';
import * as customersActions from './customers/actions.js';
import * as economyActions from './economy/actions.js';
import * as exclusiveContentActions from './exclusiveContent/actions.js';
import * as homeActions from './home/actions.js';
import * as hooksActions from './hooks/actions.js';
import * as importsActions from './imports/actions.js';
import * as insightsActions from './insights/actions.js';
import * as integrationActions from './integrations/actions.js';
import * as interactionsActions from './interactions/actions.js';
import * as keysActions from './keys/actions.js';
import * as langActions from './lang/actions.js';
import { isNotLoaded } from './Loadable/helpers.js';
import * as localActions from './local/actions.js';
import * as meActions from './me/actions.js';
import * as newInteractions from './newInteractions/actions.js';
import * as proceduresActions from './procedures/actions.js';
import * as redirectActions from './redirect/actions.js';
import * as selectedOwnersActions from './selectedOwners/actions.js';
import store from './store.js';
import * as templates from './templates/actions.js';
import * as tenantActions from './tenant/actions.js';
import * as transactionAccountActions from './transaction-accounts/actions.js';
import * as updateTypeGroupsActions from './update-type-groups/actions.js';
import * as updatesTypesActions from './update-types/actions.js';
import * as usersActions from './users/actions.js';
import * as voucherApplicationActions from './voucher-applications/actions.js';
import * as workflowsActions from './workflows/actions.js';
const loadCaseWorkerAppData = async () => {
    let state = store.getState();
    if (isNotLoaded(state.me)) {
        await meActions.get().then(() => (state = store.getState()));
    }
    if (isNotLoaded(state.allUsers)) {
        usersActions.getAll();
    }
    if (isNotLoaded(state.pausedCases[caseFilterhash(state.caseFilter)])) {
        homeActions.getPausedCases(state.caseFilter);
    }
    if (isNotLoaded(state.procedures)) {
        proceduresActions.get();
    }
    if (isNotLoaded(state.updateTypes)) {
        updatesTypesActions.types();
    }
    if (isNotLoaded(state.templates)) {
        templates.getAll();
    }
    const tenantId = state.selectedOwners[0];
    if (isNotLoaded(state.tenant) && tenantId) {
        tenantActions.get(tenantId);
    }
};
export default {
    auth: authActions,
    cases: {
        ...caseActions,
        ...casesActions,
    },
    transactionAccounts: transactionAccountActions,
    caseVouchers: caseVouchersActions,
    creditors: creditorsActions,
    customers: customersActions,
    hooks: hooksActions,
    keys: keysActions,
    economy: economyActions,
    home: homeActions,
    imports: importsActions,
    insights: insightsActions,
    workflows: workflowsActions,
    interactions: interactionsActions,
    me: meActions,
    lang: langActions,
    exclusiveContent: exclusiveContentActions,
    local: localActions,
    procedures: proceduresActions,
    redirect: redirectActions,
    owners: selectedOwnersActions,
    templates: templates,
    tenants: tenantActions,
    updates: updatesTypesActions,
    users: usersActions,
    newInteractions: newInteractions,
    loadCaseWorkerAppData,
    integrations: integrationActions,
    voucherApplications: voucherApplicationActions,
    updateTypeGroups: updateTypeGroupsActions,
};
//# sourceMappingURL=actions.js.map